module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('page-title', {
    attrs: {
      "title": "Criar",
      "moduleIdentifier": _vm.identifier
    }
  }), _vm._v(" "), _c('panel', [_c('form-group', {
    attrs: {
      "label": "Nome",
      "columns": 12
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAttribute.label),
      expression: "newAttribute.label"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newAttribute.label)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newAttribute, "label", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": _vm.$t('typeSelection.label'),
      "columns": 12
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newAttribute.typeSelection),
      expression: "newAttribute.typeSelection"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newAttribute, "typeSelection", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v(_vm._s(_vm.$t('choose.label')))]), _vm._v(" "), _vm._l((_vm.typeSelectionOptions), function(typeSelectionOption) {
    return _c('option', {
      domProps: {
        "value": typeSelectionOption
      }
    }, [_vm._v(_vm._s(_vm.$t(("typeSelection." + typeSelectionOption + ".label"))))])
  })], 2)]), _vm._v(" "), (_vm.isTypeWithOptions) ? _c('form-group', {
    attrs: {
      "label": "Opções",
      "columns": 12
    }
  }, [_c('vue-tags-input', {
    staticClass: "form-input",
    attrs: {
      "tags": _vm.options,
      "separators": [','],
      "add-on-key": [','],
      "placeholder": "",
      "allow-edit-tags": true
    },
    on: {
      "tags-changed": function (newOptions) { return _vm.options = newOptions; }
    },
    model: {
      value: (_vm.newAttribute.options),
      callback: function($$v) {
        _vm.$set(_vm.newAttribute, "options", $$v)
      },
      expression: "newAttribute.options"
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Utilize vírgula (,) para múltiplas opções.")])], 1) : _vm._e(), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Categorias",
      "columns": 12
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.marketplaceCategories,
      "label": "label",
      "track-by": "code",
      "selectLabel": "",
      "selectedLabel": "",
      "multiple": true,
      "placeholder": "Todas"
    },
    model: {
      value: (_vm.categoriesSelect),
      callback: function($$v) {
        _vm.categoriesSelect = $$v
      },
      expression: "categoriesSelect"
    }
  })], 1)], 1), _vm._v(" "), _c('panel', [_c('button', {
    staticClass: "btn btn--success",
    class: {
      'is-loading': _vm.savingAttribute
    },
    attrs: {
      "disabled": _vm.savingAttribute
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('save.label')) + "\n    ")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-231f9fa2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/MarketplaceAttribute/Create.vue
// module id = 2978
// module chunks = 0